<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    
    <vs-table ref="table"   v-model="selected" @selected="handleSelected" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          

          <!-- ADD NEW -->
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="*">
            <vs-button v-if="dataAvatar" class="mr-4" type="flat" @click="$refs.updateImgInput.click()" >{{file.name}}</vs-button>
            <vs-button v-if="!dataAvatar" class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Add Document</vs-button>
          </div>
          <div v-if="dataAvatar" >
            <vs-button small class="mr-4" type="flat" color="#999" @click="ajouter_document()">Add</vs-button>
          </div>
          <div v-if="dataAvatar" >
            <vs-button small class="mr-4" type="flat" color="#999" @click="dataAvatar = null,file = null">Annuler</vs-button>
          </div>
         
          
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="numero">Groupe</vs-th>
        <vs-th sort-key="formation">Formation</vs-th>
        
        
      </template>
      <!--template slot-scope="{data}"> 
      <div :data="tr" :key="indextr" v-for="(tr, indextr) in data">
      <div v-if="tr.name===domaineFilter.value">{{domaineFilter.value}}</div>
      <vs-tr>
        <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
        </vs-td>
      </vs-tr>
      </div>
      </template-->
      
        <template slot-scope="{data}"> 
          <tbody>
            <vs-tr   :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td filter: true>
                <p class="product-titre font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td >
                <p  class="product-numero">Groupe {{ tr.numero }}</p>
              </vs-td>
              
              <vs-td filter: true>
                <p class="product-titre"><router-link to="/">{{ tr.titre }}</router-link></p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr.lien)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="confirmDeleteRecord(tr.id)" />
              </vs-td>
             
            </vs-tr>
          </tbody>
          
        </template>
    </vs-table>
  </div>
</template>

<script>
import moduleclasse from '@/store/classe/moduleclasse.js'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data() {
  return {
      dataAvatar: null,
      file: null,
      usersid:null,
      gridApi: null,
      gridOptions: {},
      domaineFilter: { label: 'Tout', value: 'all' },
      formateurFilter: { label: 'Tout', value: 'all' },
      EtatFilter: { label: 'Tout', value: 'all' },
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    
  }
  }
  ,
  computed: {
    
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products() {
      
      return this.$store.state.classe.documents
    },
    queriedItems() {
      
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
     /* let opt=this.products.length;
      for(let i=0;i<this.products.length;i++){
      {   
       if (this.products[0].name===this.domaineFilter.value){opt--}
      }}
      console.log('opt=',opt)
      return opt+1*/
    }
  },
  watch: {
    domaineFilter(obj) {
      this.setColumnFilter("nom_domaine", obj.value)
    },
    },
  methods: {
    ajouter_document(){
      
      const obj = {    
              class_id: this.$route.params.userId,
              name: this.file.name,
              avatar: this.dataAvatar,
              
            }
      console.log('11',obj)
      this.$store.dispatch("classe/addDocuments",obj).then(()   => {    this.$store.dispatch("classe/fetchClasseDocuments",this.$route.params.userId)    })
      this.$store.dispatch("classe/fetchClasseDocuments",this.$route.params.userId)
      this.dataAvatar = null
      this.file = null
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataAvatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
         this.file = input.target.files[0]
        console.log(this.file)
      }
    },
    getOrderStatusColor(status) {
      if(status == 'on_hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    editData(name){
      window.open('https://trainingcenterback.codily.net/api/downdocument/'+name)
      // this.$store.dispatch("classe/downDocuments",name)
    },
    confirmDeleteRecord(id) {
      this.usersid = id
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirmation de la suppression`,
              text: `Vous êtes sur le point de supprimer "document ${id}"`,
              accept: this.deleteRecord,
              acceptText: "supprimer"
            })
          },
          deleteRecord() {
            /* Below two lines are just for demo purpose */
            console.log('this.usersid',this.usersid)
           // this.showDeleteSuccess()
            this.$store.dispatch("classe/removedocument", this.usersid).then(()   => { this.$store.dispatch("classe/fetchUsers");this.showDeleteSuccess() }).catch(err => { console.error(err);this.showDeleteeror()       })
            this.$store.dispatch("classe/fetchClasseDocuments",this.$route.params.userId)
            /* UnComment below lines for enabling true flow if deleting user */
            // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
            //   .then(()   => { this.$store.dispatch("classe/fetchUsers") })
            //   .catch(err => { console.error(err)       })
          },
          
  },
  created() {
    let filter = this.$route.params.userId
    console.log('filter',filter)
    if(!moduleclasse.isRegistered) {
      this.$store.registerModule('classe', moduleclasse)
      moduleclasse.isRegistered = true
    }
    // this.$store.dispatch("classe/fetchUsers")
    this.$store.dispatch("classe/fetchClasseDocuments",this.$route.params.userId)
    
  //   if(!moduledomaine.isRegistered) {
  //     this.$store.registerModule('domaine', moduledomaine)
  //     moduledomaine.isRegistered = true
  //   }
  //  this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })
  //  if(!moduleformateur.isRegistered) {
  //     this.$store.registerModule('formateur', moduleformateur)
  //     moduleformateur.isRegistered = true
  //   }
  //  this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) })
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-nom {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        padding: 0 15px !important;
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
